/**
 * components/landing/HomePage.jsx — Kalki Ai Cloud homepage (Phase 2).
 *
 * Composes every homepage section (1–14) from the Phase 2 PRD in narrative
 * order.  The SiteFrame provides the floating header, footer CTA, and
 * the enterprise footer — this file only owns the middle scroll story.
 *
 * Every section lives in /components/landing/home/*.jsx and can be edited in
 * isolation without touching the frame or other sections.  Global spacing
 * (120–180px) is baked into the sections themselves.
 */

import SiteFrame         from './SiteFrame'
import HeroSection            from './home/HeroSection'
import TrustBar               from './home/TrustBar'
import PlatformOverview       from './home/PlatformOverview'
import InteractiveProduct     from './home/InteractiveProduct'
import AIIntelligence         from './home/AIIntelligence'
import ProfessionalTrading    from './home/ProfessionalTrading'
import StrategyBuilder        from './home/StrategyBuilder'
import Backtesting            from './home/Backtesting'
import TradingAcademy         from './home/TradingAcademy'
import PlatformArchitecture   from './home/PlatformArchitecture'
import WhiteLabel             from './home/WhiteLabel'
import WhyBrand                from './home/WhyBrand'
import Pricing                from './home/Pricing'
import CustomerJourney        from './home/CustomerJourney'
import FAQ                    from './home/FAQ'
import FinalCTA               from './home/FinalCTA'

const HomePage = () => (
  // hideFooterCta=true — Section 14 (FinalCTA) already provides the
  // homepage's own bespoke closing CTA.  Suppress the shared FooterCta
  // to avoid repetition right above the footer.
  //
  // 07/2026 · Phase 2.1 · The Interactive Product Experience takes the
  // slot between Platform Overview and AI Intelligence per the Phase 2.1
  // PRD.  The stand-alone PlatformDashboard (previously §11) has been
  // removed \u2014 InteractiveProduct is a strict superset of its purpose.
  //
  // 07/2026 · Phase 2.2 · The Interactive Platform Architecture slots
  // between Trading Academy and White-Label — the "how everything works
  // together" moment that transitions from product features into the
  // white-label + business narrative.
  <SiteFrame hideFooterCta={true}>
    <HeroSection />                {/* 1  \u00b7 Hero */}
    <TrustBar />                   {/* 2  \u00b7 Trust bar */}
    <PlatformOverview />           {/* 3  \u00b7 Platform overview */}
    <InteractiveProduct />         {/* 3.5 \u00b7 Phase 2.1 signature showcase */}
    <AIIntelligence />             {/* 4  \u00b7 AI deep-dive */}
    <ProfessionalTrading />        {/* 5  \u00b7 Trading deep-dive */}
    <StrategyBuilder />            {/* 6  \u00b7 Strategy workflow */}
    <Backtesting />                {/* 7  \u00b7 Backtest report */}
    <TradingAcademy />             {/* 8  \u00b7 Academy preview */}
    <PlatformArchitecture />       {/* 8.5 \u00b7 Phase 2.2 architecture engine */}
    <WhiteLabel />                 {/* 9  \u00b7 White-label story */}
    <WhyBrand />                    {/* 10 \u00b7 Comparison */}
    <Pricing />                    {/* 11 \u00b7 Pricing (renumbered from 12) */}
    <CustomerJourney />            {/* 11.5 \u00b7 Phase 2.3 customer journey */}
    <FAQ />                        {/* 12 \u00b7 FAQ */}
    <FinalCTA />                   {/* 13 \u00b7 Final CTA */}
  </SiteFrame>
)

export default HomePage
